export function tenantInteractionProcessor(processes) {
  const grouped = {}

  processes.forEach(p => {
    const tenant = p.Tenant || 'Unknown'
    if (!grouped[tenant]) {
      grouped[tenant] = { requiresInteraction: 0, noInteraction: 0 }
    }
    if (p.RequiresUserInteraction) {
      grouped[tenant].requiresInteraction += 1
    } else {
      grouped[tenant].noInteraction += 1
    }
  })

  const data = Object.entries(grouped).map(([tenant, counts]) => ({
    tenant,
    ...counts
  }))

  const series = [
    {
      name: 'Foreground',
      data: data.map(item => item.requiresInteraction || 0)
    },
    {
      name: 'Background',
      data: data.map(item => item.noInteraction || 0)
    }
  ]

  return { series, categories: data.map(d => d.tenant) }
}